import React, { useState, useEffect } from 'react';

import Formsy from 'formsy-react';
import { Row, Col, Button, FormGroup, Label, FormBody, FormCard } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import InfoTip from 'components/InfoTip';
import PopoverConfirmation from 'components/PopoverConfirmation';
import Input from 'components/form/Input';
import Switch from 'components/form/Switch';

import ScrubOptions from '../../allocation/components/ScrubOptions';
import { useSettingStore } from '../store';

export default class Throttling extends React.Component {
  state = {
    throttling: null,
  }

  async loadData() {
    const { data } = this.props;
    this.setState(data);
  }

  componentDidMount() {
    this.loadData();
  }

  handleValidSubmit = async model => {
    if (model.throttling && model.throttling.options && model.throttling.options.threshold) {
      model.throttling.options.threshold = model.throttling.options.threshold / 100
    }
    this.props.handleSubmit({ ...this.state, ...model });
  }

  ThrottlingOptions = () => {
    const { throttling } = this.state
    const { inactive_days } = throttling && throttling.options || {}

    return <FormCard>
      <Input className='hidden' name="throttling.throttling_method" value='bucket' />
      <Row>
        <ScrubOptions.ThrottlingOptions throttling={throttling} origin="global"/>
        <Col size='4'>
          <FormGroup>
            <Label>
              Inactive Days
              <InfoTip id='inactive_days' color='secondary' disabled>
                Amount of days the bucket will clear against inactivity.
              </InfoTip>
            </Label>
            <Input name="throttling.options.inactive_days" type='number' value={inactive_days || ''} required />
          </FormGroup>
        </Col>
      </Row>
    </FormCard>
  }

  Toggle = ({ setValue, value, ...props }) => {
    const { lists: { allocations: { useLoad, items } } } = useSettingStore()
    const [isOverriden, setIsOverriden] = useState(null)

    useLoad()

    const loadData = async allocations => {
      for (const allocation of allocations) {
        if (allocation.throttling && allocation.throttling.throttling_method === 'override') {
          return setIsOverriden(true)
        }
      }
      setIsOverriden(false)
    }
    useEffect(() => {
      loadData(items)
    }, [items])

    if (!isOverriden || !value) {
      return <Switch {...props} disabled={isOverriden === null} setValue={setValue} value={value} />
    }

    return <>
      <span id='switch-disable'>
        <Switch {...props} setValue={() => { }} value={value} />
      </span>
      <PopoverConfirmation title='Can not be disabled' target='#switch-disable' trigger='legacy'>
        <h6>
          This setting is currrently being used in some allocations or subids and can not be disabled.
        </h6>
      </PopoverConfirmation>
    </>
  }

  Content = () => {
    const { throttling } = this.state
    const [enabled, setEnabled] = useState(false)
    useEffect(() => setEnabled(!!(throttling && throttling.options)), [!!(throttling && throttling.options)])

    return <>
      <HeaderContainerGrid title='Revenue Scrub' goBack={false}>
        <this.Toggle name="throttling_override" value={enabled} setValue={setEnabled} />
      </HeaderContainerGrid>
      <FormBody>
        {enabled ? <this.ThrottlingOptions /> : <Input name='throttling.options' value={undefined} type='hidden' />}
        <div className={enabled && 'mt-4'}>
          <Button color="accent" type="submit">Save</Button>
        </div>
      </FormBody>
    </>
  }

  render() {
    return <>
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <this.Content />
      </Formsy>
    </>
  }
}
